export const lightBlue = '#2B479E'
